export default { tag: 'client@2.4.0' };
